export enum PaymentMethod {
  BANK = 'BANK',
  DIRECT_BANK = 'DIRECT_BANK',
  CARD = 'CARD',
  SWISH = 'SWISH',
}
